export type NavigationOrigin =
  | 'meta-auth'
  | 'onboarding'
  | 'foryou'
  | 'search'
  | 'chat'
  | 'profile'
  | 'bookings'
  | 'settings'
  | 'creator'
  | 'deeplink'
  | 'auth'
  | null;

export type NavigationDomain =
  | 'meta-auth'
  | 'onboarding'
  | 'foryou'
  | 'search'
  | 'chat'
  | 'profile'
  | 'settings'
  | 'location'
  | 'booking'
  | 'creator'
  | 'bookingHistory'
  | 'auth';

export interface NavigationEntry {
  path: string;
  name: string;
  params?: Record<string, any>;
  query?: Record<string, any>;
  state?: Record<string, any>;
  timestamp: number;
  domain: NavigationDomain;
}

export interface ViewStack {
  entries: NavigationEntry[];
  currentIndex: number;
  domain: NavigationDomain;
  origin: NavigationOrigin;
}

export interface BookingContext {
  locationId: string;
  locationName: string;
  roomId?: string;
  roomType?: string;
  checkIn?: string;
  checkOut?: string;
  guests?: number;
}

export interface LocationContext {
  locationId: string;
  fromDomain: NavigationDomain;
  fromConversationId?: string;
  fromMessageId?: string;
}

export interface ChatContext {
  conversationId: string;
  conversationType: 'dm' | 'group';
  participantIds: string[];
}

export const TOP_LEVEL_ROUTES = [
  '/meta-auth',
  '/onboarding',
  '/foryou',
  '/auth',
  '/search',
  '/chat',
  '/profile',
  '/bookings',
  '/settings'
] as const;

export const TOP_LEVEL_ROUTE_MAP: Record<string, NavigationOrigin> = {
  '/meta-auth': 'deeplink',
  '/onboarding': 'onboarding',
  '/foryou': 'foryou',
  '/auth': 'auth',
  '/search': 'search',
  '/chat': 'chat',
  '/profile': 'profile',
  '/bookings': 'bookings',
  '/settings': 'settings'
};

export const ROUTE_DOMAIN_MAP: Record<string, NavigationDomain> = {
  '/meta-auth': 'meta-auth',
  '/onboarding': 'onboarding',
  '/foryou': 'foryou',
  '/auth': 'auth',
  '/search': 'search',
  '/chat': 'chat',
  '/profile': 'profile',
  '/profile/list': 'profile',
  '/user-profile': 'profile',
  '/user': 'profile',
  '/user-v2': 'profile',
  '/user-v2/list': 'profile',
  '/creator': 'profile',
  '/location': 'location',
  '/booking': 'booking',
  '/bookings': 'bookingHistory',
  '/settings': 'settings'
};

export interface ProfileContext {
  profileId: string;
  fromDomain: NavigationDomain;
}

export const EXIT_ROUTES: Record<NonNullable<NavigationOrigin>, string> = {
  'meta-auth': '/meta-auth',
  'onboarding': '/onboarding',
  'foryou': '/foryou',
  'search': '/search',
  'chat': '/chat',
  'profile': '/profile',
  'bookings': '/bookings',
  'settings': '/settings',
  'creator': '/profile',
  'deeplink': '/foryou',
  'auth': '/foryou'
};